import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { checkoutUrl } from '../data/landing';
import { trackAddToCart } from '../utils/metaPixel';
type CtaButtonProps = {
  href: string;
  children: React.ReactNode;
  variant?: 'gold' | 'forest';
  className?: string;
};
export function CtaButton({
  href,
  children,
  variant = 'gold',
  className = ''
}: CtaButtonProps) {
  const styles = variant === 'gold' ? 'bg-gold text-forest-deep shadow-gold hover:bg-gold-light' : 'bg-forest text-cream shadow-lift hover:bg-forest-soft';
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (href !== checkoutUrl) return;
    trackAddToCart();
    // Opened in a new tab via modifier keys: let the browser handle it.
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    // Small delay so the AddToCart event is sent before leaving the page.
    e.preventDefault();
    window.setTimeout(() => {
      window.location.href = href;
    }, 250);
  };
  return <a href={href} onClick={handleClick} className={`btn-shine group inline-flex w-full items-center justify-center gap-2 rounded-full px-6 py-4 text-center font-sans text-[15px] font-extrabold uppercase tracking-wide transition-[transform,background-color] duration-150 ease-out hover:-translate-y-0.5 active:translate-y-0 focus:outline-none focus-visible:ring-4 focus-visible:ring-gold/40 sm:w-auto sm:px-9 sm:text-base ${styles} ${className}`} data-id="element-10" data-mp="35xnziuctg2jd">
      <span data-id="element-11" data-mp="3ovryivyzol7g">{children}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-12" data-mp="3sxltqoqf0x08" />
    </a>;
}